import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35fc8e51"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，"),
  /*#__PURE__*/_createElementVNode("em", null, "或点击上传")
], -1))
const _hoisted_2 = {
  key: 1,
  style: {"text-align":"center","width":"100%"}
}

import { ref, getCurrentInstance, toRefs, watch, computed } from 'vue'
import { genFileId } from 'element-plus'
import type { UploadInstance, UploadProps, UploadRawFile } from 'element-plus'

import { getToken } from '@/utils/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'upload-import',
  props: {
    visible: { type: Boolean, default: false },
    action: { default: '' }
  },
  emits: ['closed', 'confirm'],
  setup(__props: any, { emit }) {

const props = __props;


const { proxy } = getCurrentInstance()
const url = ref(process.env.VUE_APP_BASE_URL)


const headers = {
  Authorization: "Bearer " + getToken()
}
const fileList = ref([])
const upload = ref<UploadInstance>()




const progressValue = ref(0)
const progressFlag = ref(false)

const disabled = ref(true)


// const { visible, action } = toRefs(props)
const duration = computed(() => Math.floor(progressValue.value / 10))
watch(() => props.visible, (newV) => {
  if (!newV) {
    disabled.value = true
  }

})


const handleClose = (type, val) => {
  if (!progressFlag.value) {
    progressValue.value = 0
    if (type == 'confirm') {
      emit("confirm", val);
    } else {
      emit("closed");
    }
  } else {
    proxy.$msg.warning('正在上传，请勿关闭！')
  }

}



// 文件变化
const onChange = (file) => {
  if (file) {
    disabled.value = false
  } else {
    disabled.value = true
  }

}




// 提交
const submitUpload = () => {
  upload.value!.submit()
}

// 进度条
const uploadProgress = () => {
  progressFlag.value = true
  let timer = setInterval(() => {
    progressValue.value++
    if (progressValue.value >= 72) {
      clearInterval(timer)
      timer = null
      let timerT = setInterval(() => {
        progressValue.value++
        if (progressValue.value >= 85) {
          clearInterval(timerT)
          timerT = null
        }
      }, 1200)
    }
  }, 800)
}


const handleExceed: UploadProps['onExceed'] = (files) => {
  upload.value!.clearFiles()
  const file = files[0] as UploadRawFile
  file.uid = genFileId()
  upload.value!.handleStart(file)
}

// 文件上传成功时的钩子
const uploadSuccess = (response, file, fileList) => {
  if (response && response.code == 0) {
    let finishtimer = setInterval(() => {
      if (progressValue.value < 100) {
        progressValue.value++
        if (progressValue.value >= 100) {
          clearInterval(finishtimer)
          finishtimer = null
          progressValue.value = 0
          disabled.value = true
          progressFlag.value = false

          // 上传成功之后后台返回的数据
          const { scount, ecount } = response.data
          if (ecount) {
            proxy.$msg.info(`导入成功${scount}条,导入失败${ecount}条！`)
            // emit("confirm", response.data);
          } else {
            proxy.$msg.success(`导入成功${scount}条！`)
          }
          handleClose('confirm', response.data)
          handleRemove('', [])
        }
      }
    }, 100)
  } else {
    progressValue.value = 0
    disabled.value = true
    progressFlag.value = false
    proxy.$msg.error(response.msg)
  }

};


//文件移除配置方法
const handleRemove = (file, files) => {

  disabled.value = true
  fileList.value = files;
}

return (_ctx: any,_cache: any) => {
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "上传文件",
    modelValue: props.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.visible) = $event)),
    "before-close": handleClose,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "destroy-on-close": true,
    width: "500px"
  }, {
    footer: _withCtx(() => [
      (progressFlag.value)
        ? (_openBlock(), _createBlock(_component_el_progress, {
            key: 0,
            class: "el-progress-value",
            percentage: progressValue.value,
            striped: "",
            "striped-flow": "",
            duration: duration.value
          }, null, 8, ["percentage", "duration"]))
        : _createCommentVNode("", true),
      (!progressFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "success",
              style: {"width":"200px"},
              onClick: submitUpload,
              disabled: disabled.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("开始导入 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_upload, {
        ref_key: "upload",
        ref: upload,
        class: "upload-demo",
        action: url.value + props.action,
        headers: headers,
        limit: 1,
        "auto-upload": false,
        accept: ".xlsx,.xls",
        drag: "",
        "file-list": fileList.value,
        "on-exceed": handleExceed,
        "on-progress": uploadProgress,
        "on-remove": handleRemove,
        "on-success": uploadSuccess,
        "on-change": onChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
            default: _withCtx(() => [
              _createVNode(_component_upload_filled)
            ]),
            _: 1
          }),
          _hoisted_1
        ]),
        _: 1
      }, 8, ["action", "file-list"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})